/**
 *
 * @type {{bindAll: Function, bindCartPop: Function, refreshMiniCart: Function}}
 */
ACC.cartpopup = {

    /**
     *
     */
    bindAll: function () {
        this.bindCartPop();
    },

    /**
     *
     */
    bindCartPop: function () {
        $('#cart_header').on('click', function (e) {
            //$('#cart_popup').hide();
            $.ajax({
                url: rolloverPopupUrl,
                cache: false,
                type: 'GET'
            }).done( function (result) {
                    $('#rollover_cart_popup').html(result);
                    if($('#rollover_cart_popup .slimScrollActive').length > 0) {
                      var popupHeight;
                      var popupHeightBigSize = 270;
                      var minimumSize = 20;
                      var highWidthScreenMobileSize = 115;
                      var popupHeightSmallSize = window.innerHeight - $('.total-cart').outerHeight() - $("#rollover_cart_popup .arrow_box .row-fluid").outerHeight() - $('.wrap-header').outerHeight() - 60;
                      popupHeight = (window.matchMedia("(orientation: portrait)").matches ? popupHeightBigSize : (popupHeightSmallSize > popupHeightBigSize ? popupHeightBigSize : (popupHeightSmallSize < minimumSize ? highWidthScreenMobileSize : popupHeightSmallSize)));
                      $('#rollover_cart_popup .scroll .nice-scrollable').css('height', popupHeight + "px");
                      $('#rollover_cart_popup .scroll .nice-scrollable').css('max-height', popupHeight + 'px');
                      var ps = new PerfectScrollbar('#rollover_cart_popup .scroll .nice-scrollable', {
                        suppressScrollX: true,
                        wheelPropagation: false
                      });
                      $("#rollover_cart_popup .slimScrollActive, #rollover_cart_popup .total-cart").on("touchstart ps-y-reach-end", function (event) {
                        if (event.cancelable) {
                          event.preventDefault();
                          event.stopPropagation();
                        }
                      });
                    }

                    var toolbox = $('#rollover_cart_popup .scroll .nice-scrollable'),
                      height = toolbox.height(),
                      scrollHeight = toolbox.get(0).scrollHeight;

                    toolbox.bind('mousewheel', function(e, d) {
                      if((this.scrollTop === (scrollHeight - height) && d < 0) || (this.scrollTop === 0 && d > 0)) {
                        e.preventDefault();
                      }
                    });
                    //$('#rollover_cart_popup').fadeIn();
                }
            ).fail(function(){
                console.log('Error');
            });
        });
    },

    /**
     *
     */
    refreshMiniCart: function () {
        $.get(refreshMiniCartUrl + Math.floor(Math.random() * 101) * (new Date().getTime()), function (result) {
            $('#minicart_data').html(result);
            if(result != "0") {
                $('#minicart_data').prop( "hidden", false );
            }else {
                $('#minicart_data').prop( "hidden", true );
            }
        });
    }
};

